<template>
  <v-card flat class="card-grid darkMedium--text">
    <v-skeleton-loader type="text" width="100px" />
    <div class="measures-flex">
      <div class="item">
        <v-skeleton-loader type="text" width="100px" />
        <v-skeleton-loader type="text" width="100px" />
      </div>
      <div class="item" v-for="item in 4" :key="item">
        <v-skeleton-loader type="text" width="100px" />
        <v-skeleton-loader type="text" width="100px" />
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "SkeletonTotalCard",
};
</script>

<style scoped>
.card-grid {
  display: flex;
  flex-direction: column;
  /* css commented due to unexistence alarms yet */
  /* grid-template-rows: 30px auto max-content 50px; */
  padding: 15px 15px;
  min-width: 185px;
  align-items: space-between;
}
.card-title {
  text-align: left;
  font-size: 16px;
  font-weight: 400;
}
.measures-flex {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-around;
  padding: 5px 0;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 30px;
}
p {
  margin-bottom: 2px;
}
.alarms {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.alarms > div {
  display: flex;
  justify-content: space-around;
  align-items: center;
  min-width: 40px;
}
@media (max-width: 481px) {
  .v-skeleton-loader {
    margin: 1px !important;
  }
}
</style>
